import { format } from "@formkit/tempo";
import { CalendarDateTime, getLocalTimeZone } from "@internationalized/date";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function toCalendarDateTime(input: string | null) {
	if (input === null) {
		return null;
	}

	const date = new Date(input);
	const year = date?.getFullYear();
	const month = date?.getMonth() + 1;
	const day = date?.getDate();
	const hour = date?.getHours();
	const minute = date?.getMinutes();

	return new CalendarDateTime(year, month, day, hour, minute);
}

export function formatDateInput(input: CalendarDateTime | Date | null) {
	return input === null
		? null
		: format(
				input instanceof Date ? input : input.toDate(getLocalTimeZone()),
				"YYYY-MM-DD HH:mm",
			);
}

export function formatDate(input: string | Date | null, hasTime = true) {
	return input === null
		? null
		: format(
				input instanceof Date ? input : new Date(input),
				`DD.MM.YYYY${hasTime ? " HH:mm" : ""}`,
			);
}

export function today(useSystemFormat = false) {
	return format(new Date(), useSystemFormat ? "YYYY-MM-DD" : "DD.MM.YYYY");
}

export function isNoUOrEmptyString(input?: string | null) {
	return input === null || input === undefined || input === "";
}
